import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Alert, Forms, Loader } from '../';
import { IDataStorage } from '../../core';
import { FxTranslate } from '../../core/translate';
import API from '../../services/api';
import { ICliente } from '../../services/api/entity/model';
import Common from '../../services/common';
import { GetStyleEstado } from '../../services/operaciones';
import { ICardEdit } from '../../services/operaciones/model/ICardEdit';
import Security from '../../services/seguridad';
import { Accordion, AccordionTab, Button, InputText, Timeline } from '../prime';
import styles from './card-quickinfo.module.scss';
import { UsuarioComboItem } from '../../model/seguridad';
import { ComboItem } from '../../model';

export type IProps = {
  storage: IDataStorage;
  t: FxTranslate;

  data?: ICardEdit | null | undefined;

  modo: 'hidden' | 'collapsed' | 'normal';
  width: number;
  onChangeModo: (modo: 'hidden' | 'collapsed' | 'normal') => void;

  clientes?: ICliente[] | null | undefined;
  vendedores?: ComboItem[] | null | undefined;
  usuarios?: UsuarioComboItem[] | null | undefined;
  
  onUpdateFields: (updates: { field: string, value: any }[]) => void;
}

function BoardCardFormQuickInfo({ storage, t,
  data,
  modo, width, onChangeModo,
  clientes, vendedores, usuarios, 
  onUpdateFields,
} : IProps) {
  const [ showEstados, setShowEstados ] = useState<boolean>(false);
  //const cliente = clientes?.find(p => p.id === data?.cliente.id);

  console.log("operacionestados", data?.operacionestados)
  if (modo === 'hidden') return <></>;
  return <div className={styles["card-quickinfo-container"]}>
    <i 
      className={`${styles[`collapsed-button`]} pi ${modo === 'collapsed' ? 'pi-chevron-left' : 'pi-chevron-right'}`} 
      onClick={() => onChangeModo(modo === 'collapsed' ? 'normal' : 'collapsed')}
    ></i>
    {modo === 'normal' && !!data &&
      <div className={styles["card-quickinfo-content"]}>
        <div className={styles["card-quickinfo-content-header"]}>
          <div 
            className={styles["card-quickinfo-content-header-estado"]} style={{ ...GetStyleEstado(data?.operacion?.estado ?? data?.cotizacion.estado), ...{ cursor:'pointer' } as any}}
            onClick={() => setShowEstados(!showEstados)}
          >
            {t(`@Id.Operacion.Estado#${data?.operacion?.estado ?? data?.cotizacion.estado}`)}
            <span style={{ float: 'right' }}>{!showEstados ? <>&#11206;</> : <>&#11205;</>}</span>
          </div>
          {showEstados && <div>
            <Timeline 
              className={styles["timeline"]}
              value={data.operacionestados}
              content={oe => <>
                <span style={{ ...GetStyleEstado(oe.nuevoestado), ...{ borderRadius: 4, padding: '1px 4px' }}}>
                  {t(`@Id.Operacion.Estado#${oe.nuevoestado}`)}
                </span>
                <span style={{ marginLeft: 7 }}>{oe.creausunombre ?? oe.creausulogin} - {window.format(oe.creafecha, 'ddd dd/MM/yyyy HH:mm')}</span>
              </>}
              opposite={oe => <>
                {window.format(oe.creafecha, 'ddd dd/MM/yyyy HH:mm')}
              </>}
            />
          </div>}
          {/*<Loader loading={!clientes}>
            <Forms.Input 
              disabled 
              className={styles["fix-form-component"]}
              title={t("QuickInfo.Field.Cliente.Title")} 
              value={cliente?.nombre} 
            />
          </Loader>*/}
          <Loader loading={!vendedores}>
            <Forms.Dropdown 
              title={t("QuickInfo.Field.Vendedor.Title")} placeholder={t("@Id#SinSeleccionar")}
              className={styles["fix-form-component"]}
              options={() => vendedores ?? []}
              value={!!data?.operacion?.id ? data?.operacion?.idvendedor : data?.cotizacion.idvendedor}
              disabled={(!data?.operacion?.id && !Security.HasPermiso(95)) || (!!data?.operacion?.id && !Security.HasPermiso(85))}
              optionLabel='show' optionValue='id'
              onChange={(v,e) => onUpdateFields([ 
                !!data?.operacion?.id ? undefined : { field: 'cotizacion.idvendedor', value: v },
                !data?.operacion?.id ? undefined : { field: 'operacion.idvendedor', value: v },
              ].filter(p => !!p) as any)}
            />
          </Loader>
        </div>
        <div className='hseparator' />
        <Accordion activeIndex={0}>
          <AccordionTab header={t("QuickInfo.Mensajes.Title")}>
            <ChatComponent data={data} t={t} onUpdateFields={onUpdateFields} usuarios={usuarios} />
          </AccordionTab>
          <AccordionTab header={t("QuickInfo.Historial.Title")}>
            * historial de cambios?
          </AccordionTab>
        </Accordion>
      </div>
    }
  </div>;
}
export default connect((s:any) => ({ storage:s.main }))(BoardCardFormQuickInfo);

type ChatComponentProps = {
  t: FxTranslate;

  data: ICardEdit | null | undefined;

  usuarios?: UsuarioComboItem[] | null | undefined;

  onUpdateFields: (updates: { field: string, value: any }[]) => void;
}
function ChatComponent ({ t, 
  data, 
  usuarios, 
  onUpdateFields 
} : ChatComponentProps) {
  const [ inputText, setInputText ] = useState<string>('');
  const [ sending, setSending ] = useState<boolean>(false);

  useEffect(() => {
    $(`#chat-messages-container`).scrollTop($("#chat-messages-container")[0].scrollHeight);
  }, [data])

  const dias = Common.array.distinct(data?.cotizacionmensajes?.map(p => window.format(p.creafecha, 'ddd dd/MM/yyyy', window.app_usems)) ?? []).sort((a,b) => a > b ? 1 : -1);

  const onSendMessage = () => {
    setSending(true);
    API.entity().cotizacion().upsertMensaje({ idcotizacion: data?.cotizacion.id, texto: inputText }).then(res => {
      Alert.reponse(res);
      if (!!data && !!res.success && res.data) {
        setInputText('');
        if (!data?.cotizacionmensajes) data.cotizacionmensajes = [];
        data.cotizacionmensajes.push(res.data);
        onUpdateFields([
          { field: `random`, value: Math.random() }, // para que actualize el objeto
        ])
      }
    }).catch(err => Alert.error(t("Seccion.Pago.Dialog.Comprobante.Guardar.Error.Titulo"), err))
    .finally(() => {
      setSending(false);
    })
  }

  return <Loader loading={sending}>  
    <div style={{ width: '100%', height: 'calc(100vh - 450px)', display: 'flex', flexDirection: 'column' }}>
      <div id="chat-messages-container" style={{ height: 'calc(100vh - 450px - 40px)', display: 'flex', flexDirection: 'column', gap: 10, overflowY: 'auto' }}>
        {dias.map(dia => <>
          <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div style={{ background: '#ccc', borderRadius: 5, padding: '3px 6px', fontSize: 12, fontWeight: 600 }}>{dia}</div>
          </div>
          {data?.cotizacionmensajes?.filter(msg => window.format(msg.creafecha, 'ddd dd/MM/yyyy', window.app_usems) === dia).sort((a,b) => new Date(a.creafecha) > new Date(b.creafecha) ? 1 : -1).map(msg => 
            Security.User?.id === msg.creausu ?
              // Usuario Actual (lado derecho del chat)
              <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                <div style={{ width: '80%', display: 'flex', flexDirection: 'column', backgroundColor: '#dfd', borderRadius: 5, padding: 8, borderRight: '2px solid #cec', borderBottom: '2px solid #cec' }}>
                  <div>{msg.texto}</div>
                  <div style={{ textAlign: 'right', fontSize: 10 }}>{window.format(msg.creafecha, 'HH:mm', window.app_usems)}</div>
                </div>
              </div>
            : // Otro Usuario (lado izquierdo del chat)
            <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
              <div style={{ width: '80%', display: 'flex', flexDirection: 'column', backgroundColor: '#ddd', borderRadius: 5, padding: 8, borderRight: '2px solid #ccc', borderBottom: '2px solid #ccc' }}>
                <div style={{ color: 'var(--primary)' }}>
                  {((usr) => <>
                    <img height={24} width={24} alt="" style={{ borderRadius: 25, marginRight: 5 }} src={!!usr?.avatar?.url ? usr.avatar.url : '/images/avatar.png'} />
                    {`${usr?.nombre}${!usr?.apellido ? '' : ` ${usr?.apellido}`} (${!!usr?.roles && usr.roles.length > 0 && t(usr.roles.sort((a,b) => (a?.id??0) > (b?.id??0) ? 1 : 0)[0].showKey ?? '@Id#Ninguno')})`}
                  </>)(usuarios?.find(p => p.id === msg.creausu))}
                </div>
                <div>{msg.texto}</div>
                <div style={{ textAlign: 'right', fontSize: 10 }}>{window.format(msg.creafecha, 'HH:mm', window.app_usems)}</div>
              </div>
            </div>
          )}
        </>)}

      </div>
      <div style={{ height: 40, display: 'flex', flexDirection: 'row', gap: 5, paddingTop: 5, alignItems: 'center' }}>
        <div style={{ width: '100%' }}>
          <InputText 
            style={{ width: '100%', fontSize: 12 }}
            value={inputText}
            onKeyUp={e => {
              if (e.key.toLowerCase() === 'enter' && inputText.length > 0) {
                onSendMessage();
                return false;
              } else {
                return true;
              }
            }}
            onChange={e => setInputText(e.target.value)}
          />
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            label={t("QuickInfo.Chat.Btn.Send")}
            className="p-button-success" style={{ fontSize: 12 }}
            disabled={!inputText || inputText === ''}
            onClick={() => onSendMessage()}
          />
        </div>
      </div>
    </div>
  </Loader>;
}